import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Reusable seasonal category filter dropdown. Selecting a category filters
 * athletes whose season_categories contain that category_code (primary or additional).
 * Value "all" disables filtering.
 */
export default function CategoryFilter({ categories = [], value = "all", onChange, className = "w-48 h-11", testId = "filter-category" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={className}><SelectValue placeholder="Categoria" /></SelectTrigger>
      <SelectContent className="max-h-80">
        <SelectItem value="all">Tutte le categorie</SelectItem>
        {categories.filter((c) => c.is_active !== false).map((c) => (
          <SelectItem key={c.id} value={c.code} data-testid={`${testId}-opt-${c.code}`}>
            {c.male_name === c.female_name ? c.male_name : `${c.male_name} / ${c.female_name}`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
